import PageName from "../../components/PageName";
import React, {useState} from "react";
import RSAForm from "../../components/RSA/RSAForm";
import RSATable from "../../components/RSA/RSATable";
import TimeOutActivityLayout from "../auth/inactivity-timeout-v2";

const RegisterAFriend = () => {
    const [showFormPage, setShowFormPage] = useState(true);

    const toggleShowFormPage = () => setShowFormPage(!showFormPage)


    return (
        <TimeOutActivityLayout>
        <div className="transaction-page">
            <PageName pageName={"Registered A Friend"} />
            { !showFormPage ?
                <RSATable onClickMainButton={toggleShowFormPage} />
                :
                <RSAForm onClose={toggleShowFormPage} />
            }
        </div>
        </TimeOutActivityLayout>
    )
}
export default RegisterAFriend;